import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DOW } from 'src/shared/models/module-manager/module-manager-settings.models';
import { CvConfigurationService } from '../services/cv-configuration.service';
import { DateRangeSelectorService } from '../date-range-selector/date-range-selector.service';
import { CVLocalizationService } from '../services/cv-localization.service';

@Component({
    selector: 'cv-generic-dow-selector',
    templateUrl: './generic-dow-selector.component.html',
    styleUrl: './generic-dow-selector.component.scss'
})
export class GenericDowSelectorComponent {
    _selectedDaysOfWeek: DOW = 127 as DOW;

    @Input() 
    set selectedDaysOfWeek(value: number) {
        if (value > 0 || value < 128) {
            this._selectedDaysOfWeek = value;
        } else {
            this._selectedDaysOfWeek = DOW.All; // Default to all days selected
        }
    }
    @Input() textSection: string = 'Games';
    
    @Input() textTitle: string = 'Select_Days_Used';
    
    @Output() selectedDaysOfWeekChange = new EventEmitter<DOW>();

    readonly days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    daysInOrder: string[] = [];
    daysLocalizedInOrder: string[] = [];

    checkedDays = {
        getDay: (day: DOW) => (this._selectedDaysOfWeek | day) === this._selectedDaysOfWeek,
        setDay: (day: DOW, enabled: boolean) => {
            if (enabled)
                this._selectedDaysOfWeek |= day;
            else
                this._selectedDaysOfWeek &= ~day;
            this.selectedDaysOfWeekChange.emit(this._selectedDaysOfWeek);
        },

        get Sun() { return this.getDay(DOW.Sunday); },
        set Sun(v) { this.setDay(DOW.Sunday, v); },

        get Mon() { return this.getDay(DOW.Monday); },
        set Mon(v) { this.setDay(DOW.Monday, v); },

        get Tue() { return this.getDay(DOW.Tuesday); },
        set Tue(v) { this.setDay(DOW.Tuesday, v); },

        get Wed() { return this.getDay(DOW.Wednesday); },
        set Wed(v) { this.setDay(DOW.Wednesday, v); },

        get Thu() { return this.getDay(DOW.Thursday); },
        set Thu(v) { this.setDay(DOW.Thursday, v); },

        get Fri() { return this.getDay(DOW.Friday); },
        set Fri(v) { this.setDay(DOW.Friday, v); },

        get Sat() { return this.getDay(DOW.Saturday); },
        set Sat(v) { this.setDay(DOW.Saturday, v); },
    };

    constructor(
        private config: CvConfigurationService,
        private service: DateRangeSelectorService,
        private cvLocalizationService: CVLocalizationService
    ) {

    }

    async ngOnInit() {
        await this.cvLocalizationService.GetSection("Common");

        const weekStart: number = this.config.weekStart;
        this.daysInOrder = [];
        for (let i = 0; i < 7; i++) {
            const currDayNumber = (weekStart + i) % 7;
            const currDay = this.days[currDayNumber].slice(0, 3);
            const currDayLocalized = this.cvLocalizationService.getCachedText("Common",
                this.days[currDayNumber], this.days[currDayNumber]).slice(0, 3);
            this.daysInOrder.push(currDay);
            this.daysLocalizedInOrder.push(currDayLocalized);
        }
    }

    onDaysChanged() {
        this.selectedDaysOfWeekChange.emit(this._selectedDaysOfWeek);
    }
}
